const getters = {
  inElectron: state => state.app.inElectron,
  size: state => state.app.size,
  zoom: state => state.app.zoom,
  measureRateScale: state => state.app.measureRateScale,
  bookMaterial: state => state.app.bookMaterial,
  token: state => state.user.token,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  phone: state => state.user.phone,
  userInfo: state => state.user.userInfo,
  // 当前授课的班级信息
  classData: state => state.user.classData,
  accessKeyId: state => state.user.accessKeyId,
  evaluateUserId: state => state.user.evaluateUserId,
  bucketName: state => state.user.bucketName,
  accessKeySecret: state => state.user.accessKeySecret,
  ossParam: state => state.user.ossParam,
  waitingList: state => state.user.waitingList,
  activeAnswer: state => state.user.activeAnswer,
  classroom: state => state.user.classroom,
  pkSelectBook: state => state.user.pkSelectBook,
  pkSelectUnit: state => state.user.pkSelectUnit,
  loginPlatform: state => state.user.loginPlatform,
  wordTitleName: state => state.word.wordTitleName,
  wordBook: state => state.word.wordBook,
  wordBookMaterial: state => state.word.wordBookMaterial,
  wordBookUnit: state => state.word.wordBookUnit,
  exerciseWordList: state => state.word.exerciseWordList,
  wordList: state => state.pk.wordList,
  maximized: state => state.window.maximized,
  textBook: state => state.text.textBook,
  textBookMaterial: state => state.text.textBookMaterial,
  textBookUnit: state => state.text.textBookUnit,
  audioList: state => state.params.audioList,
  paperGroupList: state => state.params.paperGroupList,
  auxiliaryBook: state => state.auxiliary.auxiliaryBook,
  auxiliaryBookUnit: state => state.auxiliary.auxiliaryBookUnit,
  auxiliaryPaper: state => state.auxiliary.auxiliaryPaper,
  specialBook: state => state.special.specialBook,
  specialBookUnit: state => state.special.specialBookUnit,
  specialPaper: state => state.special.specialPaper,
  digitalTextbookModule: state => state.digitalBook.digitalTextbookModule,
  eTextbook: state => state.digitalBook.eTextbook,
  digitalBook: state => state.digitalBook.digitalBook,
  catalogList: state => state.digitalBook.digitalBook?.digitalBookCatalogList || [],
  catalogListByUse: state => state.digitalBook.catalogListByUse,
  pdfIdMap: state => state.digitalBook.pdfIdMap,
  pdfList: state => state.digitalBook.digitalBook?.pageControlList || [],
  pdfInfo: state => state.digitalBook.pdfInfo,
  localList: state => state.offline.localList,
  file2PathMap: state => state.offline.file2PathMap,
  name2PathMap: state => state.offline.name2PathMap,
  bookMap: state => state.offline.bookMap,
  localChange: state => state.offline.localChange,
  routerList: state => state.router.routerList,
  showExportProgress: state => state.app.showExportProgress,
  sentenceGroup: state => state.sentence.sentenceGroup,
  pictureBookData: state => state.pictureBook.pictureBookData,
  unitData: state => state.unit.unitData,
  isGradeSchool: state => state.user.userInfo?.thirdPartyType === 7,
  classDeviceType: state => state.app.classDeviceType,
  showBrushVisible: state => state.app.showBrushVisible,
  // 学段是否是初中
  isJuniorSection: state => state.user.userInfo?.section === 7,
  // 学段是否是高中
  isHighSection: state => state.user.userInfo?.section === 8,
  // 学段是否是小学
  isPrimarySection: state => state.user.userInfo?.section === 9,
  // 听写的单词列表
  wordListForDictation: state => state.wordDictation.wordListForDictation
}
export default getters
